<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <EXCMNoteForm
            v-if="item"
            :handle-submit="onSendForm"
            :handle-update-field="updateField"
            :values="item"
            :errors="violations"
            :initial-values="retrieved" />
        </div>
      </div>
      <button
        type="button"
        @click="goBack()"
        class="btn btn-default">{{$t('buttons.goBack')}}</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXCMNoteForm from './Form.vue'
// import { checkPagePermission } from '@/utils/checkRoles.js'

export default {
  components: {
    EXCMNoteForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'excmnote/update/isLoading',
      error: 'excmnote/update/error',
      deleteError: 'excmnote/del/error',
      deleteLoading: 'excmnote/del/isLoading',
      created: 'excmnote/create/created',
      deleted: 'excmnote/del/deleted',
      retrieved: 'excmnote/update/retrieved',
      updated: 'excmnote/update/updated',
      violations: 'excmnote/update/violations'
    })
  },

  beforeCreate () {
    // checkPagePermission('notes', 'EXCMNoteUpdate')
    return true
  },

  watch: {
    updated (val) {
      if (val) {
        this.$router.go(-1)
      }
    },
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.go(-1)
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    goBack () {
      this.$router.go(-1)
    },
    ...mapActions({
      createReset: 'excmnote/create/reset',
      deleteItem: 'excmnote/del/del',
      delReset: 'excmnote/del/reset',
      retrieve: 'excmnote/update/retrieve',
      updateReset: 'excmnote/update/reset',
      update: 'excmnote/update/update',
      updateRetrieved: 'excmnote/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this excmnote ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
